import {Tooltip, withStyles} from '@material-ui/core';

export const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#f5f5f5',
        color: 'rgba(0, 0, 0, 0.87)',
        fontSize: 11,
    },
}))(Tooltip);

const styles = theme => ({
    row:{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        direction:'column',
    },
});

export default styles;


